module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav has-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "exact": "",
      "to": "/",
      "active-class": "is-active"
    }
  }, [_vm._v("The Basics")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/vux",
      "active-class": "is-active"
    }
  }, [_vm._v("Vux")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/view",
      "active-class": "is-active"
    }
  }, [_vm._v("Iview")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2546c512"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 125
// module chunks = 1